<script lang="ts">
    export let text: string = 'Click me';
    export let showIcon: boolean = true;
    export let disabled: boolean = false;
</script>

<button class="btn-back dont-break" on:click class:icon={showIcon} {disabled}>
    {text}
</button>

<style>
    .btn-back {
        color: black;
        padding: 0 12px;
        border-radius: 5px;
        border: none;
        cursor: pointer;
        font-size: 16px;
        min-width: 140px;
        height: 32px;
        position: relative;
    }
    .showIcon {
        padding-right: 40px;
    }
    .btn-main icon {
        background-image: url('Icons/svg/navigate_next_FILL0_wght400_GRAD0_opsz24.svg');
        background-repeat: no-repeat;
        background-position: 0px center;
        background-size: 24px;
        position: absolute;
        width: 20px;
        height: 20px;
        padding: 0 10px;
        margin: 0 10px;
        opacity: 0.6;
    }
    .btn-main[disabled] {
        background-color: var(--automapa-grey-dark);
        cursor: not-allowed;
    }
</style>
